"use strict";

var flattenDeep = require('lodash/flattenDeep');

var computeProperty = require('./computeProperty');

function formatBasedOnSettings(product, productSetting, componentSettings) {
  if (productSetting.component) {
    // this is a COMPONENT setting
    // get the name of the component collection
    //
    // {
    //     "component": "a7Envelopes", <-
    //     "function": "defaultEnvelope"
    // }
    //
    var collectionType = productSetting.component; //
    // Get the specified formatting function
    // {
    //     "component": "a7Envelopes",
    //     "function": "defaultEnvelope" <-
    // }
    //

    var settingType = productSetting["function"] || 'default'; //
    // get the ComponentCollection and its name (e.g. a7Envelopes)
    //

    var componentCollection = product[collectionType];

    if (!componentCollection) {
      throw new Error("product.".concat(collectionType, " did not return a ComponentCollection"), collectionType, product);
    }

    var componentName = componentCollection.type;

    if (componentCollection.quantity === 0) {
      return null;
    } //
    // go get the component settings by name
    // {
    //    "a7Envelopes": {} <- would go up the chain to find "defaultEnvelope" setting
    // }
    //


    var settings = componentSettings[componentName] && componentSettings[componentName][settingType] || componentSettings[settingType] // check for a function by that name
    || componentSettings["default"]; // last resort

    if (!settings) {
      // if, for some reason, we've gone all the way up the chain
      // and componentsSettings.default does not exist, throw an error.
      throw new Error("componentSettings.default not found for ".concat(componentName, "/").concat(settingType));
    } // map over the instances of each Component in the ComponentCollection


    return componentCollection.collection.map(function (component) {
      // compute the properties of interest
      var properties = settings.map(function (setting) {
        var prop = computeProperty(component, setting);
        return prop;
      }); // filter out the ones with no value

      return properties.filter(function (prop) {
        return prop && prop.value !== '';
      });
    });
  } // this is a product setting


  return computeProperty(product, productSetting);
}
/**
 * @param {Product} product
 * @param {*} options
 * @param {*} options.products - product settings
 * @param {*} options.components - component settings
 * @returns {Array<ComputedProperty>}
 */


function extractProperties(product, _ref, formatter) {
  var products = _ref.products,
      components = _ref.components;

  // map over Product properties
  if (!products[product.type]) {
    throw new Error("Expected formatter to include settings for ".concat(product.type));
  }

  if (!products[product.type]["default"]) {
    throw new Error("Expected formatter to include settings for ".concat(product.type, ".default"));
  }

  if (product.type === 'PhotoSaveTheDates') {
    debugger;
  } // use either a specified formatter (e.g. shoppingCart) or the default


  var formatOptions = products[product.type][formatter] || products[product.type]["default"]; // map over the options

  var nestedPropertiesArray = formatOptions.map(function (settings) {
    return formatBasedOnSettings(product, settings, components, formatter);
  }); // remove the falsy values

  var propertiesArray = flattenDeep(nestedPropertiesArray).filter(function (str) {
    return !!str;
  });
  return propertiesArray;
}

module.exports = extractProperties;